module.exports = __webpack_public_path__ + "3d4e38e0a7c1c23c913351f783f37355.png";